import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast. Four areas (29/10/26): Overview, Schemes, Set targets, Results.
const OverviewPage = lazy(() => import("./web/Overview.js").then((m) => ({ default: m.OverviewPage })));
const SchemesPage = lazy(() => import("./web/SchemesPage.js").then((m) => ({ default: m.SchemesPage })));
const TargetsPage = lazy(() => import("./web/Targets.js").then((m) => ({ default: m.TargetsPage })));
const ResultsPage = lazy(() => import("./web/Results.js").then((m) => ({ default: m.ResultsPage })));
const LynkedCheckPage = lazy(() => import("./web/LynkedCheck.js").then((m) => ({ default: m.LynkedCheckPage })));

export default defineWebModule({ manifest, pages: { "": OverviewPage, "/schemes": SchemesPage, "/targets": TargetsPage, "/results": ResultsPage, "/lynked-check": LynkedCheckPage } });
